import React from "react";
import { motion } from "framer-motion";


import img1 from "../assets/kollage/1.png";
import img2 from "../assets/kollage/2.png";
import img3 from "../assets/kollage/3.png";
import img4 from "../assets/kollage/4.png";
import img5 from "../assets/kollage/5.png";
import img6 from "../assets/kollage/6.png";
import img7 from "../assets/kollage/7.png";
import img8 from "../assets/kollage/8.png";
import img9 from "../assets/kollage/9.png";
import img10 from "../assets/kollage/10.png";
import img11 from "../assets/kollage/11.png";
import img12 from "../assets/kollage/12.png";
import img13 from "../assets/kollage/13.png";
import img14 from "../assets/kollage/14.png";
import img15 from "../assets/kollage/15.png";
import img16 from "../assets/kollage/16.png";
import img17 from "../assets/kollage/17.png";
import img18 from "../assets/kollage/18.png";
import img19 from "../assets/kollage/19.png";
import img20 from "../assets/kollage/20.png";
import img21 from "../assets/kollage/21.png";
import img22 from "../assets/kollage/22.png";
import img23 from "../assets/kollage/23.png";
import img24 from "../assets/kollage/filetmijohn.png";

const item = {
  hidden: { opacity: 0, y: 50 },
  show: { opacity: 1, y: 0 },
};

const collageImages = [
  {
    src: img1,
    alt: "Artist",
    delay: 10,
    top: "0%",
    left: "20%",
    height: "100%",
  },
  {
    src: img2,
    alt: "Artist",
    delay: 9.5,
    top: "60%",
    left: "40%",
    height: "30%",
  },
  {
    src: img3,
    alt: "Artist",
    delay: 9,
    left: "30%",
    bottom: "-10%",
    height: "50%",
  },
  {
    src: img4,
    alt: "Artist",
    delay: 8.5,
    right: "10%",
    bottom: "-10%",
    height: "50%",
  },
  {
    src: img5,
    alt: "Artist",
    delay: 8,
    top: "-10%",
    left: "40%",
    height: "30%",
  },
  {
    src: img6,
    alt: "Artist",
    delay: 7.5,
    top: "-10%",
    right: "-5%",
    height: "60%",
  },
  {
    src: img7,
    alt: "Artist",
    delay: 7,
    top: "30%",
    right: "20%",
    height: "60%",
  },
  {
    src: img8,
    alt: "Artist",
    delay: 6.5,
    top: "-20%",
    left: "10%",
    height: "60%",
  },
  {
    src: img9,
    alt: "Artist",
    delay: 6,
    top: "0%",
    left: "-10%",
    height: "70%",
  },
  {
    src: img10,
    alt: "Artist",
    delay: 5.5,
    left: "-10%",
    bottom: "-10%",
    height: "70%",
  },
  {
    src: img11,
    alt: "Artist",
    delay: 5,
    top: "-10%",
    left: "20%",
    height: "30%",
  },
  {
    src: img12,
    alt: "Artist",
    delay: 4.5,
    right: "-10%",
    bottom: "-10%",
    height: "70%",
  },
  {
    src: img13,
    alt: "Artist",
    delay: 4,
    top: "50%",
    left: "-10%",
    height: "35%",
  },
  {
    src: img14,
    alt: "Artist",
    delay: 3.5,
    top: "0%",
    right: "0%",
    height: "45%",
  },
  {
    src: img15,
    alt: "Artist",
    delay: 3,
    top: "-10%",
    left: "-10%",
    height: "60%",
  },
  {
    src: img16,
    alt: "Artist",
    delay: 2.5,
    left: "20%",
    bottom: "0%",
    height: "80%",
  },
  {
    src: img17,
    alt: "Artist",
    delay: 2,
    left: "10%",
    bottom: "10%",
    height: "70%",
  },
  {
    src: img18,
    alt: "Artist",
    delay: 1.5,
    right: "10%",
    bottom: "10%",
    height: "70%",
  },
  {
    src: img19,
    alt: "Artist",
    delay: 1,
    right: "10%",
    bottom: "15%",
    height: "50%",
  },
  {
    src: img20,
    alt: "Artist",
    delay: 0.5,
    top: "5%",
    right: "10%",
    height: "40%",
  },
  {
    src: img21,
    alt: "Artist",
    delay: 10.5,
    top: "-5%",
    left: "55%",
    height: "50%",
  },
  {
    src: img22,
    alt: "Artist",
    delay: 11,
    right: "-5%",
    bottom: "-10%",
    height: "30%",
  },
  {
    src: img23,
    alt: "Artist",
    delay: 11.5,
    top: "10%",
    left: "10%",
    height: "90%",
  },
  {
    src: img24,
    alt: "Artist",
    delay: 5.5,
    top: "40%",
    right: "13%",
    height: "8%",
    href: "http://www.filetmijohn.com"
  },
];

const CollageImages = () => {
  return (
    <div>
      {collageImages.map((image) => (
        <motion.img
          key={image.src}
          variants={item}
          initial="hidden"
          loading="eager"
          animate="show"
          transition={{ duration: 2, delay: collageImages.indexOf(image) / 2 }}
          src={image.src}
          alt={image.alt}
          style={{
            position: "absolute",
            top: image.top,
            right: image.right,
            bottom: image.bottom,
            left: image.left,
            height: image.height,
            width: "auto",
            maxWidth: "none"
          }}
        />
      ))}
    </div>
  );
};

export default CollageImages;
